if (!customElements.get('natunora-joints-ingredients')) {
  customElements.define('natunora-joints-ingredients', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.mobile = matchMedia('(max-width: 989px)');
      this.states = new Set();
      this.cards = [...this.querySelectorAll('.n-joints-ingredients__card')];
      this.dataset.enhanced = '';
      this.cards.forEach(card => card.querySelector('button').addEventListener('click', () => {
        if (this.states.has(card)) this.states.delete(card);
        else this.states.add(card);
        this.update();
      }, { signal }));
      this.mobile.addEventListener('change', () => this.update(), { signal });
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.n-joints-ingredients__card');
        if (card) { this.states.add(card); this.update(); }
      }, { signal });
      this.update();
    }
    disconnectedCallback() { this.controller?.abort(); }
    update() {
      this.cards.forEach(card => {
        const expanded = !this.mobile.matches || this.states.has(card);
        const button = card.querySelector('button');
        const panel = card.querySelector('.n-joints-ingredients__panel');
        card.dataset.open = String(expanded);
        button.disabled = !this.mobile.matches;
        button.setAttribute('aria-expanded', String(expanded));
        panel.inert = !expanded;
        panel.setAttribute('aria-hidden', String(!expanded));
      });
    }
  });
}
